import React from "react";

const Footer = () => {
  return (
    <section className="bg-main2 text-white py-16 text-center">
      <p>
        Copyright © 2022 |{" "}
        <a
          href="https://www.linkedin.com/in/mostafizur131/"
          rel="noreferrer"
          className="text-secondary"
        >
          Mostafizur Rahman
        </a>{" "}
        | All Right Reserved
      </p>
    </section>
  );
};

export default Footer;
